// src/utils/toastUtils.js
import { toast } from "react-toastify";

// Function to show success toast
export const showSuccessToast = (message) => {
  toast.success(message, {
    position: "top-center",
    theme: "light",
    autoClose: 3000,
    className: "absolute top-20",
  });
};

// Function to show error toast
export const showErrorToast = (message) => {
  toast.error(message, {
    position: "top-center",
    theme: "light",
    autoClose: 3000,
    className: "absolute top-20",
  });
};

// Function to show info toast
export const showInfoToast = (message) => {
  toast.info(message, {
    position: "top-center",
    theme: "light",
    autoClose: 3000,
    className: "absolute top-20",
  });
};

// Function to show warning toast
export const showWarningToast = (message) => {
  toast.warn(message, {
    position: "top-center",
    theme: "light",
    autoClose: 3000,
    className: "absolute top-20",
  });
};

export const showErrorToastforLogin = (message) => {
  toast.error(message, {
    position: "top-center",
    theme: "light",
    autoClose: 3000,
    className: "absolute ",
  });
};